/* Wear Rose cart-drawer upsell quick-add (2026-07-08, one-click 2026-08-02).
   Lives OUTSIDE the re-rendered .drawer__inner, so it uses document-level
   event delegation — buttons keep working after Dawn swaps the drawer HTML.

   One click = added. The variant is resolved SERVER-SIDE in cart-drawer.liquid,
   which inherits the size already chosen in the cart, so there is no picker here.
   Deliberately no 'change' listener: these tiles sit inside <cart-drawer-items>,
   whose CartItems base class treats any bubbling change event as a line-quantity
   edit (cart.js validateQuantity -> parseInt(value)). */
(function () {
  'use strict';

  function config() {
    if (typeof window.fetchConfig === 'function') return window.fetchConfig();
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    };
  }

  /* A silent failure is indistinguishable from a dead button — always say something. */
  function showError(message) {
    var errEl = document.getElementById('CartDrawer-CartErrors');
    if (errEl) errEl.textContent = message || '';
    if (message) console.error('wr-upsell:', message);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('.wr-upsell__add');
    if (!btn) return;
    if (btn.tagName === 'A') return; // link fallback: let the browser navigate
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var variantId = Number(btn.dataset.variantId);
    if (!variantId) {
      showError('Sorry — this item is unavailable right now.');
      return;
    }
    btn.classList.add('is-loading');
    showError('');

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }

    var body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', Object.assign(config(), { body: body }))
      .then(function (response) {
        return response.json().catch(function () {
          throw new Error('Cart returned a non-JSON response (' + response.status + ')');
        });
      })
      .then(function (state) {
        // Shopify error payload ({status, message, description})
        if (state.status) {
          showError(state.description || state.message || 'Could not add that item.');
          return;
        }
        // NOTE: deliberately NOT publishing PUB_SUB_EVENTS.cartUpdate. Dawn's
        // CartDrawerItems subscribes to it and bails only for source 'cart-items'
        // (cart.js), so publishing kicks off a SECOND ?section_id=cart-drawer fetch
        // that replaceWith()s cart-drawer-items and races the render below.
        // renderContents already rebuilds the drawer AND the header count bubble
        // from this same response.
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state.sections) {
          cartDrawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        showError('Could not add that item. Please try again.');
        console.error('wr-upsell add error:', err);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  });
})();
